import { gql } from "@apollo/client";

export const LOGIN_MUTATION = gql`mutation Login($input: LoginInput!) {
    login(input: $input) {
        accessToken
        refreshToken
        user {
          id
          email
          firstName
          lastName
          role
          schema
        }
    }
}`;

// Forgot Password Mutation (Request Password Reset)

export const FORGOT_PASSWORD_MUTATION = gql`
  mutation RequestPasswordReset($input: ResetPasswordRequestInput!) {
    requestPasswordReset(input: $input)
  }
`;

// Reset Password Mutation

export const RESET_PASSWORD_MUTATION = gql`
  mutation ResetPassword($input: ResetPasswordInput!) {
    resetPassword(input: $input)
  }
`;

// Company Signup Mutation (creates tenant company with schema)

export const SIGNUP_MUTATION = gql`
  mutation Signup($input: SignupInput!) {
    signup(input: $input) {
      accessToken
      refreshToken
      user {
      id
      email
      firstName
      lastName
        role
        companyId
        schema
      }
    }
  }
`;

export const ACCEPT_INVITATION_MUTATION = gql`
mutation AcceptInvitation($input: AcceptInvitationInput!) {
    acceptInvitation(input: $input) {
        accessToken
        refreshToken
        __typename
    }
}
`;

// Send Invitation Mutation (using backend API)

export const SEND_INVITATION_MUTATION = gql`
  mutation SendInvitation($input: SendInvitationInput!) {
    sendInvitation(input: $input) {
      id
      email
      role
    }
  }
`;

// Resend Invitation Mutation

export const RESEND_INVITATION_MUTATION = gql`
  mutation ResendInvitation($input: ResendInvitationInput!) {
    resendInvitation(input: $input){
      id
        email
        role
        status
        expiresAt
        }
  }
`;
